module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABoAAAAUBAMAAABhbjCNAAAAFVBMVEXQDDPcSWbjb4bqk6Tsna30xc7///9YSqhOAAAAI0lEQVQY02NgAAK3RAYkQFueEhCEJStBAEMaMkDjoaqkszsB1PUZK3FK3KYAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/images/flags/dk.png
// module id = 268
// module chunks = 0